import { Injectable } from '@angular/core';
import { BaseService, UrlParam } from "./classes/BaseService";
import { HttpClient } from "@angular/common/http";

@Injectable()
export class SearchService extends BaseService{

  apiUrl = "SearchForItems.php?"

  constructor(protected http: HttpClient) {
    super(http);
  }

  searchForItems(store: string, itemType: string, country: string, searchTerm: string, offset: number, limit:number) {
    let url = this.serverUrl + this.apiUrl + this.buildUrlParams(
      new UrlParam("store", store),
      new UrlParam("itemType",itemType),
      new UrlParam("country", country),
      new UrlParam("searchTerm", searchTerm),
      new UrlParam("offset", offset.toString()),
      new UrlParam("limit", limit.toString()),
      new UrlParam("action", "search2"),
    );
    return this.get(url);
  }

  getSuggestions(store: string, itemType: string, country: string, searchTerm: string, offset: number, limit:number) {
    let url = this.serverUrl + this.apiUrl + this.buildUrlParams(
      new UrlParam("store", store),
      new UrlParam("itemType",itemType),
      new UrlParam("country", country),
      new UrlParam("searchTerm", searchTerm),
      new UrlParam("action", "getSuggestions"),
      new UrlParam("offset", offset.toString()),
      new UrlParam("limit", limit.toString())
    );
    return this.get(url);
  }

}
